import { createFileRoute, Outlet } from "@tanstack/react-router";
import { pageMeta, ldScripts, breadcrumbLd } from "@/lib/seo";
import { SiteNav } from "@/components/layout/SiteNav";
import { SiteFooter } from "@/components/layout/SiteFooter";

export const Route = createFileRoute("/services")({
  head: () => ({
    ...pageMeta({
      path: "/services/",
      title: "SEO & AI Search Services · Optimize Plus",
      description: "Austin SEO services for growth-stage businesses. Local SEO, technical SEO, GEO, and content strategy designed to rank on Google and get cited by AI.",
    }),
    scripts: ldScripts(
      breadcrumbLd([{ name: "Home", path: "/" }, { name: "Services", path: "/services/" }])
    ),
  }),
  component: () => (
    <div>
      <SiteNav />
      <main id="main" tabIndex={-1}>
        <Outlet />
      </main>
      <SiteFooter />
    </div>
  ),
});
